import { useEffect } from 'react'
import { Button } from '@/UIComponents2/Button'
import { Card } from '@/components/SessionSettings/internal/Card'
import useAppUpdateService from '@/services/appUpdateService'
import { env } from '@/services/EnvironmentVariables'
import useEnterDevModeActions from '@/actions/useEnterDevModeActions'
import { useTranslation } from 'react-i18next'
import DownloadIcon from '@/CustomIcons/DownloadIcon'
import { BugReportField } from './BugReportField'
import BuildInfo from '@/build-info'
import { CardHeader } from '@/components/SessionSettings/internal/CardHeader'
import { cardXPad } from '@/components/SessionSettings/internal/Card'
import { Field } from '@/components/SessionSettings/internal/Field'
import { MuseLogo } from '@/components/MuseLogo'
import { Separator } from '@/components/SessionSettings/internal/Separator'
import ForwardIcon from '@/CustomIcons/ForwardIcon'
import ElectronIPC from '@/services/ElectronIPC'
import * as Constants from '@/services/Constants'
import { cn } from '@/utlis/cn'
import Tooltip from '@/UIComponents2/Tooltip'
import InfoIcon from '@/CustomIcons/InfoIcon'

export function AboutSection() {
    const { t } = useTranslation()
    const { checkForUpdate, isUpdateAvailable, runAppUpdate } = useAppUpdateService()
    const { countClick } = useEnterDevModeActions()

    useEffect(() => {
        checkForUpdate()
    }, [checkForUpdate])

    return (
        <Card className="px-0 md:px-0">
            <div className="flex flex-col gap-6">
                <CardHeader icon={InfoIcon} title="About" className={cn('pb-4', cardXPad)} />
                <Field title={<MuseLogo onClick={countClick} className="w-[92px]" />}>
                    <div className="flex items-center justify-between">
                        <div>
                            <div title={(BuildInfo as unknown as any)?.app_version_full || ''}>{env.APP_VERSION}</div>
                            {env.APP_BUILD_CODE && <div className="t-sm">{env.APP_BUILD_CODE}</div>}
                        </div>
                        {isUpdateAvailable && (
                            <div>
                                <Tooltip
                                    text={t('An update to version {{version}} is available!', {
                                        version: isUpdateAvailable.to,
                                    })}
                                >
                                    <Button
                                        variant="primary"
                                        onClick={runAppUpdate}
                                        className="flex items-center gap-2"
                                    >
                                        <DownloadIcon style={{ fontSize: '1.3rem' }} /> {t('Update Available')}
                                    </Button>
                                </Tooltip>
                            </div>
                        )}
                    </div>
                </Field>
                <Separator />
                <Field title={t('Helpful Links')}>
                    <Links />
                </Field>

                <Separator />

                <Field title={t('Report an issue')}>
                    <BugReportField />
                </Field>
            </div>
        </Card>
    )
}

function Links() {
    const { t } = useTranslation()

    return (
        <ul className="list-none">
            <li>
                <Button
                    variant="link"
                    onClick={() => {
                        ElectronIPC.openLinkInBrowser(Constants.links.website_index)
                    }}
                >
                    <ForwardIcon />
                    <span className="ml-2">{t('Website')}</span>
                </Button>
            </li>
            <li>
                <Button
                    variant="link"
                    onClick={() => {
                        ElectronIPC.openLinkInBrowser(Constants.links.website_faq)
                    }}
                >
                    <ForwardIcon />
                    <span className="ml-2">{t('FAQ')}</span>
                </Button>
            </li>
            <li>
                <Button
                    variant="link"
                    onClick={() => {
                        ElectronIPC.openLinkInBrowser(Constants.links.website_tutorials)
                    }}
                >
                    <ForwardIcon />
                    <span className="ml-2">{t('Tutorials')}</span>
                </Button>
            </li>
            <li>
                <Button
                    variant="link"
                    onClick={() => {
                        ElectronIPC.openLinkInBrowser(Constants.links.website_bugreports)
                    }}
                >
                    <ForwardIcon />
                    <span className="ml-2">{t('Contact Us')}</span>
                </Button>
            </li>
        </ul>
    )
}
